import api from './api';
import { Course, CourseAssignment } from '../types';

interface AssignCourseData {
    userId: string;
    courseId: string;
    dueDate: string;
}

export const courseService = {
    getAllCourses: async (): Promise<Course[]> => {
        const response = await api.get('/courses');
        return response.data;
    },

    assignCourse: async (data: AssignCourseData) => {
        const response = await api.post('/admin/assign-course', data);
        return response.data;
    },

    getCourseStats: async () => {
        const response = await api.get('/courses/stats');
        return response.data;
    },

    getAdminCourses: async (): Promise<Course[]> => {
        const response = await api.get('/admin/courses');
        return response.data;
    },

    getDashboardActivity: async () => {
        const response = await api.get('admin/recent-activity');
        return response.data;
    },

    getUserCourses: async (): Promise<CourseAssignment[]> => {
        const response = await api.get(`/users/courses`);
        return response.data;
    },

    updateLessonCompletion: async (courseId: string, lessonId: string, completed: boolean) => {
        const response = await api.post('/lessons/completion', {
            courseId,
            lessonId,
            completed
        });
        return response.data;
    },
    completeCourse: async (courseId: string) => {
        const response = await api.post(`/courses/${courseId}/complete`);
        return response.data;
    },

    getCourseDetails: async (courseId: string): Promise<Course> => {
        const response = await api.get(`/courses/${courseId}/details`);
        return response.data;
    }
}; 